import * as React from "react";

const SignInUser: React.FC = () => {
    return (
        <svg width="62" height="56" viewBox="0 0 62 56" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M37.89 27.6c15.395 1.171 23.31 8.831 23.31 18.111 0 3.468-1.104 6.71-3.292 9.472h-9.467c1.96-2.87 3.068-6.076 3.068-9.472 0-4.998-2.395-9.6-6.412-13.289C38.673 38.177 34.49 47.316 32.526 55.2h-3.847c-1.967-7.884-6.151-17.024-12.575-22.778-4.017 3.689-6.411 8.29-6.411 13.29 0 3.395 1.108 6.6 3.069 9.471h-9.47C1.109 52.421 0 49.179 0 45.711c0-9.28 7.915-16.94 23.31-18.111 3.806 3.498 6.133 10.635 7.29 17.062 1.156-6.427 3.486-13.564 7.29-17.062zM30.6 0C36.896 0 42 5.104 42 11.4s-5.104 11.4-11.4 11.4l-.294-.004C24.146 22.64 19.2 17.598 19.2 11.4l.004-.294C19.36 4.946 24.402 0 30.6 0zm0 5.7l-.219.004A5.7 5.7 0 0024.9 11.4l.004.219A5.7 5.7 0 1030.6 5.7z"
                fill="currentColor"
            />
        </svg>
    );
};

export default React.memo(SignInUser);
